















































































































import { Component, Vue } from 'vue-property-decorator'
import UpsertWidgetModal from '@/components/modals/UpsertWidgetSetting.vue'
import NotFound from '@/components/common/NotFound.vue'
import { mapGetters } from 'vuex'
import { WidgetModel } from '@/_models/WidgetModel'

@Component({
  components: {
    NotFound
  },
  computed: {
    ...mapGetters('widgets', {
      canEdit: 'canEdit'
    }),
    ...mapGetters('widgets', {
      canDelete: 'canDelete'
    })
  }
})
export default class ListWidgetSetting extends Vue {
  public pageFilters: any = {
    currentPage: 1,
    perPage: 10
  }

  dragging: { index?: number; row?: any } = {}

  get isLoading() {
    return this.$store.getters['widgets/isWidgetLoading']
  }

  get widgetSettingsData() {
    return this.$store.state.widgets?.all?.items
  }

  public tableSortSettings: [string, string] = ['order', 'asc']

  public handleOpenModalUpsert(widgetData?: WidgetModel) {
    this.$buefy.modal.open({
      parent: this,
      component: UpsertWidgetModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        formData: widgetData
      }
    })
  }

  public confirmSingleDelete(id: string) {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        await this.processDelete(id)
      }
    })
  }

  public async processDelete(id: string) {
    return this.$store.dispatch('widgets/deleteOne', id).then(() => {
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  dragstart(payload) {
    this.dragging.index = payload.index
    this.dragging.row = payload.row
    payload.event.dataTransfer.effectAllowed = 'copy'
  }

  dragover(payload) {
    payload.event.dataTransfer.dropEffect = 'copy'
    payload.event.target.closest('tr').classList.add('is-selected')
    payload.event.preventDefault()
  }

  dragleave(payload) {
    payload.event.target.closest('tr').classList.remove('is-selected')
    payload.event.preventDefault()
  }

  drop(payload) {
    payload.event.target.closest('tr').classList.remove('is-selected')

    // In same order not thing happen
    if (payload.index === this.dragging.index) {
      return
    }

    const data = {
      toIndex: payload.index,
      toData: {
        order: payload.row.order,
        id: payload.row._id
      },
      fromIndex: this.dragging.index,
      fromData: {
        order: this.dragging.row.order,
        id: this.dragging.row._id
      }
    }

    this.$store.dispatch('widgets/reOrderItems', data).then(() => {
      this.$buefy.toast.open(
        this.$t('messages.re_order_success', {
          from: this.dragging.row.order,
          to: payload.row.order
        }) as string
      )
    })
  }
}
